<template>
    <div>
        <b-card>
            <div slot="header">
                <i class="fa fa-list-ul" aria-hidden="true"></i>
                    Categories list
                <div class="card-header-actions">
                    <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
                    <small class="text-muted">docs</small>
                    </a>
                </div>
            </div>
            <b-row>
                <b-col sm="12">
                    <alert-fail :show="'' != errorMessage"> {{ errorMessage }} </alert-fail>
                    <b-table
                          stacked="sm"
                          :busy="isBusy"
                          :current-page="pagination.currentPage"
                          :per-page="pagination.numberPerPage"
                          class="table-privilege"
                          tbody-class="tbody" hover
                          thead-tr-class="thead-news"
                          @row-clicked="viewDetails"
                          selectable
                          selectedVariant="single"
                          :fields="fields"
                          :items="categories">
                          <template slot="icon" slot-scope="row">
                            <img class="icon" :src="row.item.icon || '/images/101/thumbnail.png'" alt="Thumbnail">
                          </template>
                            <div slot="table-busy" class="text-center text-dark my-2">
                                <b-spinner variant="dark" class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                    </b-table>
                    <hr/>
                    <b-row>
                    <b-col>
                        <app-paging
                            :totalRows="pagination.totalRows"
                            :page="pagination.currentPage"
                            @changePage="changePage"/>
                    </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import AppPaging from '../../components/Pagination.vue';
import AlertFail from '../../components/alert/AlertFail';

export default {
  data () {
    return {
      errorMessage: '',
      isBusy: false,
      isLoading: false,
      categories: [],
      fields: [
        { key: 'icon' },
        { key: 'name' }
      ],
      pagination: {
        currentPage: 1,
        numberPerPage: process.env.VUE_APP_NUMBER_PER_PAGE,
        totalRows: 30
      }
    };
  },
  methods: {
    viewDetails (e) {
      this.$router.push({ name: '101categories-details', params: { id: e.id } });
    },
    changePage (e) {
      this.pagination.currentPage = e;
      this.getData();
    },
    handleError (error) {
      this.errorMessage = error.response ? error.response.data : error.message;
    },
    getData () {
      this.isBusy = true;
      this.axios.get(process.env.VUE_APP_URL_MQDC_API + '/categories', { headers: {
        Accept: 'application/json'
      } })
        .then(response => {
          const data = response.data.data;
          this.pagination.totalRows = data.length;
          data.forEach(category => {
            this.categories.push({
              id: category.id,
              name: category.name,
              icon: category.icon
            });
          });
          this.isBusy = false;
        })
        .catch(error => {
          this.handleError(error);
        });
    }
  },
  computed: {
    totalRows () {
      return this.categories.length;
    }
  },
  mounted () {
    this.getData();
  },
  components: {
    'app-paging': AppPaging,
    AlertFail
  }
};
</script>

<style scoped>
.icon{
        max-width: 75px;
        max-height: 75px;
    }
</style>
